module.exports = {
  PROMO: 'promo',
  TRANSACTION: 'transactional'
}
